"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */
function matchQuery(queryConfig, queryParams, pathMatch) {
  var queryMatch = {};
  var isMatchingQuery = queryConfig.every(function (query) {
    // eslint-disable-next-line prefer-const
    var _query$split = query.split('='),
        _query$split2 = (0, _slicedToArray2["default"])(_query$split, 2),
        names = _query$split2[0],
        value = _query$split2[1];

    var negation = false;
    /* Check if negative matching query param (eg 'foo!=1') */

    if (query.includes('!=')) {
      names = names.substring(0, names.length - 1);
      negation = true;
    }
    /* Allow alternate query params presence (eg 'foo|bar') */


    var matched = names.split('|').map(function (name) {
      var isOptional = false;
      /* Check if optional query param (eg 'foo?') */

      if (name.includes('?')) {
        // eslint-disable-next-line no-param-reassign
        name = name.substring(0, name.length - 1);
        isOptional = true;
      }
      /* First check if queryParams contains the relevant param */


      var match = Object.prototype.hasOwnProperty.call(queryParams, name);
      /* Save actual value so we expose it as part of match object */

      if (match) {
        queryMatch[name] = queryParams[name] || '';
      }
      /* If no value matching required or it is optional and the param is missing */


      if (!value || isOptional && !match) {
        return isOptional || match;
      }

      if (value.startsWith('(')) {
        /* Handle value being a regexp eg 's=(\\d+)' */
        match = new RegExp("^".concat(value, "$")).test(queryParams[name] || '');
      } else {
        /* Handle value exact matching eg 's=123' */
        match = queryParams[name] === value;
      }

      return negation ? !match : match;
    });
    /* If at least one of alternate query params matches then it is a match */

    return matched.includes(true);
  });
  return isMatchingQuery ? _objectSpread(_objectSpread({}, pathMatch), {}, {
    query: queryMatch
  }) : null;
}

var _default = matchQuery;
exports["default"] = _default;